module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-pictogram-5cb82e515cf46260d4fec96e00d67aec.svg";